import { render } from "./AdultsSectionFive.vue?vue&type=template&id=1d8b130b&scoped=true"
import script from "./AdultsSectionFive.vue?vue&type=script&lang=js"
export * from "./AdultsSectionFive.vue?vue&type=script&lang=js"

import "./AdultsSectionFive.vue?vue&type=style&index=0&id=1d8b130b&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1d8b130b"]])

export default __exports__